import { ReactNode } from "react";
import * as S from '../styles'

export function ColumnHeader({ icon, title }: { icon: ReactNode; title: string }) {
  return (
    <S.ColumnHeader>
      <div className="column-header-icon">{icon}</div>
      <span>{title}</span>
    </S.ColumnHeader>
  );
}